import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createVNode as _createVNode, withCtx as _withCtx, withModifiers as _withModifiers, TransitionGroup as _TransitionGroup, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "gfu-1of1 gfu-2of3--xl gfu-project-banner-gallery__media" }
const _hoisted_2 = ["data-qa"]
const _hoisted_3 = ["onClick"]
const _hoisted_4 = {
  key: 1,
  class: "gfu-gallery gfu-gallery--medium gfu-gallery__no-items"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_video_frame = _resolveComponent("video-frame")
  const _component_base_icon = _resolveComponent("base-icon")
  const _component_base_button = _resolveComponent("base-button")
  const _component_base_carousel = _resolveComponent("base-carousel")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    ($options.slides.length > 0)
      ? (_openBlock(), _createBlock(_component_base_carousel, {
          key: 0,
          class: "gfu-project-slider gfu-embed gfu-embed--16x9",
          autoplay: $options.autoplay,
          "max-indicators": 9,
          onChange: $options.onChange
        }, {
          default: _withCtx(({ onAction, stopAutoplay, startAutoplay }) => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.slides, (slide) => {
              return (_openBlock(), _createElementBlock("div", {
                key: slide.galleryItemID,
                class: _normalizeClass(['gfu-project-slider__slide gfu-embed__item ', { 'is-active': slide.isActive }]),
                style: _normalizeStyle(slide.style),
                "data-qa": `gallery-image:${slide.galleryItemID}`
              }, [
                (slide.isVisible && slide.videoUrl)
                  ? (_openBlock(), _createBlock(_component_video_frame, {
                      key: 0,
                      url: slide.videoUrl,
                      "is-current": slide.isActive,
                      "is-watching": slide.isWatching,
                      "is-visible-forced": slide.isVisibleForced,
                      onPlay: $event => ($options.onPlay(onAction)),
                      onStopAutoplay: stopAutoplay,
                      onStartAutoplay: startAutoplay,
                      "data-qa": `gallery-video:${slide.galleryItemID}`
                    }, null, 8 /* PROPS */, ["url", "is-current", "is-watching", "is-visible-forced", "onPlay", "onStopAutoplay", "onStartAutoplay", "data-qa"]))
                  : _createCommentVNode("v-if", true)
              ], 14 /* CLASS, STYLE, PROPS */, _hoisted_2))
            }), 128 /* KEYED_FRAGMENT */))
          ]),
          nav: _withCtx(({ onNext, onPrev }) => [
            _createVNode(_component_base_button, {
              class: "gfu-project-slider-nav gfu-project-slider-nav--prev",
              theme: "white",
              shape: "circle",
              shadow: "tight",
              "aria-label": _ctx.Resources.Common.ScrollLeftButtonLabel,
              onClick: onPrev,
              "data-qa": "gallery-button:SlideLeft"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_base_icon, {
                  name: "chevron-left",
                  class: "_tc--accent",
                  size: "lg"
                })
              ]),
              _: 1 /* STABLE */
            }, 8 /* PROPS */, ["aria-label", "onClick"]),
            _createVNode(_component_base_button, {
              class: "gfu-project-slider-nav gfu-project-slider-nav--next",
              theme: "white",
              shape: "circle",
              shadow: "tight",
              "aria-label": _ctx.Resources.Common.ScrollRightButtonLabel,
              onClick: onNext,
              "data-qa": "gallery-button:SlideRight"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_base_icon, {
                  name: "chevron-right",
                  class: "_tc--accent",
                  size: "lg"
                })
              ]),
              _: 1 /* STABLE */
            }, 8 /* PROPS */, ["aria-label", "onClick"])
          ]),
          indicators: _withCtx(({ onSetCurrentIndex, indicators }) => [
            _createVNode(_TransitionGroup, {
              name: "gfu-project-slider-indicators",
              tag: "div",
              class: "gfu-project-slider-indicators"
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(indicators, (indicator) => {
                  return (_openBlock(), _createElementBlock("a", {
                    key: `i${indicator}`,
                    href: "#",
                    class: _normalizeClass(['gfu-project-slider-indicators__indicator', { 'is-active': $options.isCurrent(indicator)}]),
                    onClick: _withModifiers($event => (onSetCurrentIndex(indicator)), ["prevent"])
                  }, null, 10 /* CLASS, PROPS */, _hoisted_3))
                }), 128 /* KEYED_FRAGMENT */))
              ]),
              _: 2 /* DYNAMIC */
            }, 1024 /* DYNAMIC_SLOTS */)
          ]),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["autoplay", "onChange"]))
      : (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("div", null, [
            _createVNode(_component_base_icon, { name: "image" })
          ])
        ]))
  ]))
}